import { metrics } from '@atlassian/browser-metrics';

// From: embedded-confluence ViewPage or EditPage
// To: iframe onload event
export var iframeOnloadMetric = function iframeOnloadMetric() {
  return metrics.interaction({
    key: 'embedded-confluence-time-to-iframe-onload'
  });
};

// From: embedded-confluence ViewPage init
// To: in iframe page tti
export var embeddedViewPageIframeTtiMetric = metrics.interaction({
  key: 'embedded-confluence-view-page-iframe-tti'
});

// From: embedded-confluence EditPage init
// To: in iframe page tti
export var embeddedEditPageIframeTtiMetric = metrics.interaction({
  key: 'embedded-confluence-edit-page-iframe-tti'
});

// From: in iframe view page edit button click
// To: in iframe edit page fmp
export var embeddedViewToEditTransitionMetric = metrics.interaction({
  key: 'embedded-confluence-view-to-edit-transition'
});